import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import "./contact.css";
import { post_order } from '../../services/services';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const CONTACT = () => {

    const [name, setname] = useState("");
    const [tel, settel]=useState("");
    const [email, setemail]=useState("");
    const [msj, setmsj]=useState("");
    const [captcha, setcaptcha]=useState(null);
    const recaptchaRef = useRef(null);

    const sendemail = async() =>{

        if(email === "" || msj === "" || name === "" || tel === ""){
            alert("Valores faltantes en el formulario");
            return null;
        }
        if(!captcha){
            alert("Por favor confirma que no eres un robot");
            return null;
        }
        var data = {
            email: email,
            id_freezer: "",
            message: msj,
            name: name,
            order:"",
            phone: tel,
            type: "contactar",
            recaptcha_token: captcha
        }

        try{
            const d = await post_order(data);
            console.log(d);
            setname("");
            settel("");
            setemail("");
            setmsj("");
            alert("Correo enviado con éxito");
        }catch(err){
            console.log(err);
            alert("No se pudo enviar el correo, intenta de nuevo");
        }
        // el token de reCAPTCHA es de un solo uso
        setcaptcha(null);
        recaptchaRef.current?.reset();

    }


  return (
    <div className='contact-container' id='contact-container'>
        <div className='contact-content'>
            <div className='contact-grid'>
                <div className='contg1'>
                    <div className='address'>
                        <div className='hours'>
                            <h2>Horario</h2>
                            <p>Lunes a Sabado: 8am - 6pm</p>
                        </div>
                        <div className='mail'>
                            <h2>Correo</h2>
                            <p>atencion.clientes@fricongelados.com</p>
                        </div>
                        <div className='city'>
                            <h2>Dirección</h2>
                            <p>Calle Jalapilla #654, Lote 2, Orizaba, Veracruz, C.P. 94393, México.</p>
                        </div>
                        
                    </div>
                    <div className='gmaps'>
                        <iframe 
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d472.02614291717003!2d-97.0794865!3d18.8333663!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c4fd0064e4ec59%3A0x4b29ff52b6776119!2sFricongelados%20Citlaltepetl!5e0!3m2!1ses-419!2smx!4v1775764463027!5m2!1ses-419!2smx" 
                            allowfullscreen="" 
                            loading="lazy" 
                            referrerpolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </div>
                </div>
                <div className='contg2'>
                    <div className='forms'>
                    <h2>CONTACTO</h2>
                    <input 
                        placeholder='Nombre Completo'
                        value={name}
                        onChange={(e)=>setname(e.target.value)}
                    ></input>
                    <input 
                        placeholder='Número Teléfono'
                        value={tel}
                        onChange={(e)=>settel(e.target.value)}    
                    ></input>
                    <input 
                        placeholder='Correo Electrónico'
                        value={email}
                        onChange={(e)=>setemail(e.target.value)}
                    ></input>
                    <input 
                        placeholder='Mensaje'
                        value={msj}
                        onChange={(e)=>setmsj(e.target.value)}
                    ></input>
                    <div className='recaptcha'>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={RECAPTCHA_SITE_KEY}
                            hl='es-419'
                            onChange={(token)=>setcaptcha(token)}
                            onExpired={()=>setcaptcha(null)}
                        />
                    </div>
                    <div className='submit'>
                        <button onClick={()=>sendemail()}>ENVIAR</button>
                    </div>

                   
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
  )
}
